import { LoggingLevel } from '../app/shared/utils/logging-level';

export var environment: any = {
  production: true,

  dev: true,

  // Feature flags
  siteSettingsEnabled: true,

  //version of app
  version: '0.1.21.1',
  releaseDate: 'Oct 21th 2022',

  //AWS Configuration
  region: 'us-east-3',

  //Cognito Configuration
  userPoolId: 'us-east-1_crzJlN08K',
  clientId: 'f2f5rig2cf5j2nlk4tat7klo0',
  tokenKey: 'tokenKey',

  //Language Configuration
  selectedLangKey: 'language',
  defaultLanguage: 'English',

  logs: [
    LoggingLevel.FATAL,
    LoggingLevel.ERROR,
    LoggingLevel.WARNING,
    LoggingLevel.INFO,
    LoggingLevel.DEBUG,
    LoggingLevel.TRACE,
  ],

  //API Configuration
  baseUrl: 'https://h4lp4rq0fb.execute-api.us-east-1.amazonaws.com/dev_v1',
  graphqlUrl:
    'https://f75b47blg5gdxkrwyviumdcdve.appsync-api.us-west-1.amazonaws.com/graphql',
  captcha: '6LeU1U0UAAAAALwPOOCK6atkwqel168NP0PsqBOG',

  invisibleCaptcha: '6Ldci-AcAAAAAFj8k22Py-UbWkrZDMY3T1nxhpdS',

  //OneTrust Cookies data-domain-script
  dataDomainScript: '9db01ce6-2efb-4d90-960c-4b696575988b-test',
  // sec * min
  totalDelayTimeOut: 60 * 10,
  delayWarningTime: 60 * 1,

  codeExpiration: '24 hours',

  app: {
    weiser: '/weiserApp',
    kwikset: '/kwiksetApp',
  },
  // Google Authentication URL
  googleLoginParams: {
    BASEURL: 'https://xell-alexa.auth.us-east-1.amazoncognito.com/',
    identityProvider: 'Google',
    redirectUri: 'http://localhost:4200/redirect',
    redirectLogoutUri: 'http://localhost:4200/home/login',
    responseType: 'code',
    clientId: 'ms2s7q6ebi14q5d1srm188dle',
    scope: 'email+openid+phone+profile+aws.cognito.signin.user.admin',
    grantType: 'authorization_code',
    authorization:
      'Basic bXMyczdxNmViaTE0cTVkMXNybTE4OGRsZToxMTdjcnMxb2x0MHV1bGVjbjBta2E2Y2NkYnFscm1zYjg5aGo3Mm1icnRycjE0ZjRxM2Rt',
  },
};
